module.exports = __webpack_public_path__ + "static/media/SM-MT-TRIAL1-if-correct.7f50e713.mp3";